/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ size: NonNullable<unknown> }} Filesize_Kilobytes1Inputs */

const en_filesize_kilobytes1 = /** @type {(inputs: Filesize_Kilobytes1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.size} KB`)
};

/**
* | output |
* | --- |
* | "{size} KB" |
*
* @param {Filesize_Kilobytes1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const filesize_kilobytes1 = /** @type {((inputs: Filesize_Kilobytes1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filesize_Kilobytes1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_filesize_kilobytes1(inputs)
});
export { filesize_kilobytes1 as "fileSize_kilobytes" }